import "core-js/modules/es.array.index-of";
// @ is an alias to /src
import NavComponent from "@/components/Nav.vue";
import FooterComponent from "@/components/Footer.vue";
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "App",
  components: {
    NavComponent: NavComponent,
    FooterComponent: FooterComponent
  },
  setup: function setup() {
    return useI18n();
  },
  watch: {
    $route: function $route(to) {
      // test if queryString locale is allowed, the change accordingly
      var routeLocale = ["en-us", "pt-br"].indexOf(to.query.locale || "") > -1 ? to.query.locale : "pt-br";
      this.locale = routeLocale;
    }
  }
});